import { render } from "./MainHeaderSearch.vue?vue&type=template&id=457f3892"
import script from "./MainHeaderSearch.vue?vue&type=script&lang=js"
export * from "./MainHeaderSearch.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__